module.exports = __webpack_public_path__ + "fonts/Roboto-Light.7035e32.eot";